import {
    Box,
    ChakraProvider,
    Flex,
    HStack,
    Stack,
    StackDivider,
} from '@chakra-ui/react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useSelector } from 'react-redux';

import { useLayoutContext } from 'context/LayoutContext';

import chakratheme from '@/chakratheme';
import { shouldShowWholesalerPaymentBanner } from '@/lib/data-router/hooks/useThemeHelper';
import SidebarNoRerender from './SidebarNoRerender';
import {
    SidebarAppVersion,
    renderThumb,
    renderTrack,
    renderView,
} from './index';

const Sidebar = () => {
    const { isMenuCollapse } = useLayoutContext();
    const { requiredScope, wholesalerPaymentBanner } = useSelector(
        (state) => state.login,
    );
    const isWholesalerPaymentBannerShow = shouldShowWholesalerPaymentBanner(
        requiredScope,
        wholesalerPaymentBanner,
    );

    return (
        <ChakraProvider resetCSS theme={chakratheme}>
            <Flex as="section" minH="100vh">
                <Stack
                    flex="1"
                    maxW={{
                        base: 'full',
                        sm: `${isMenuCollapse ? '64px' : '240px'}`,
                    }}
                    pt={{ base: '6', sm: '8' }}
                    pb={2}
                    justifyContent="space-between"
                    divider={
                        <StackDivider
                            aria-label="app-divider"
                            minW="213px"
                            mx="auto!important"
                            borderColor="dark.border"
                        />
                    }
                    bg="dark.bgDark">
                    {/* Main items section */}
                    <Flex
                        as={Scrollbars}
                        autoHide
                        autoHeightMax="670px"
                        renderTrackVertical={renderTrack}
                        renderThumbVertical={renderThumb}
                        renderView={renderView}>
                        <Stack
                            className="main-items"
                            spacing={
                                isWholesalerPaymentBannerShow ? '104px' : 8
                            }>
                            <Stack spacing={4} divider={<StackDivider />}>
                                <Box h={4} aria-label="menu-top-spacing" />
                            </Stack>
                            <Stack spacing="1" px={{ base: 4, sm: '6px' }}>
                                <SidebarNoRerender />
                            </Stack>
                        </Stack>
                    </Flex>

                    {/* App version section  */}
                    <Flex direction="column" className="app-version">
                        <HStack
                            spacing="3"
                            alignItems="center"
                            justify="space-between">
                            <SidebarAppVersion />
                        </HStack>

                        <Stack
                            spacing={1}
                            zIndex={99}
                            className={isMenuCollapse ? 'mr-0' : 'mr-1.5'}>
                            {/* Open/Collapse Menu */}
                            {/* <WrapItem
                                justifyContent="flex-end"
                                paddingInline={isMenuCollapse ? '1' : '0'}>
                                <Tooltip
                                    padding="6px"
                                    label={
                                        <SidebarTooltip
                                            isMenuCollapse={isMenuCollapse}
                                        />
                                    }
                                    hasArrow
                                    placement="right-end">
                                    <IconButton
                                        size="sm"
                                        aria-label="Show/Hide Menu"
                                        onClick={onMenuToggle}
                                        border="none"
                                        bg="none"
                                        _active={{ bg: 'none' }}
                                        _hover={{ bg: 'transparent' }}
                                        _focus={{ bg: 'transparent' }}
                                        color="white"
                                        icon={
                                            <ArrowLeftIcon
                                                sx={{
                                                    transform:
                                                        isMenuCollapse &&
                                                        'rotate3d(0, 1, 0, -180deg)',
                                                    transition: 'all .4s',
                                                }}
                                            />
                                        }
                                    />
                                </Tooltip>
                            </WrapItem> */}
                        </Stack>
                    </Flex>
                </Stack>
            </Flex>
        </ChakraProvider>
    );
};
export default Sidebar;
